function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// import css file
import "../styles/tailwind.css";
import "../styles/index.scss";
import React, { useEffect, useState } from "react";
import Head from "next/head";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GoogleAnalytics, event } from "nextjs-google-analytics";
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { ThemeProvider as FlowbiteThemeProvider } from "flowbite-react";
import { Config } from "../../app.config";
import { FlowbiteTheme, FlowbiteThemeApply } from "../utils/Constants";
import { SearchContextProvider } from "../utils/Context";
export function reportWebVitals(_ref) {
  var id = _ref.id,
    name = _ref.name,
    label = _ref.label,
    value = _ref.value;
  event(name, {
    category: label === "web-vital" ? "Web Vitals" : "Next.js custom metric",
    value: Math.round(name === "CLS" ? value * 1000 : value),
    // values must be integers
    label: id,
    // id unique to current page load
    nonInteraction: true // avoids affecting bounce rate.
  });
}
var client = new QueryClient();
export default function App(_ref2) {
  var Component = _ref2.Component,
    pageProps = _ref2.pageProps;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showChild = _useState2[0],
    setShowChild = _useState2[1];
  useEffect(function () {
    setShowChild(true);
  }, []);
  if (!showChild) {
    return null;
  }
  if (typeof window === 'undefined') {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("title", null, Config.name), /*#__PURE__*/React.createElement("meta", {
      charSet: "UTF-8"
    }), /*#__PURE__*/React.createElement("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1, maximum-scale=1"
    }), /*#__PURE__*/React.createElement("meta", {
      "http-equiv": "cache-control",
      content: "max-age=0"
    }), /*#__PURE__*/React.createElement("meta", {
      "http-equiv": "cache-control",
      content: "no-cache"
    }), /*#__PURE__*/React.createElement("meta", {
      "http-equiv": "expires",
      content: "0"
    }), /*#__PURE__*/React.createElement("meta", {
      "http-equiv": "expires",
      content: "Tue, 01 Jan 1980 1:00:00 GMT"
    }), /*#__PURE__*/React.createElement("meta", {
      "http-equiv": "pragma",
      content: "no-cache"
    }), /*#__PURE__*/React.createElement("meta", {
      name: "msapplication-TileColor",
      content: "#2d89ef"
    }), /*#__PURE__*/React.createElement("meta", {
      name: "msapplication-config",
      content: "none"
    }), /*#__PURE__*/React.createElement("link", {
      rel: "shortcut icon",
      href: "favicon.ico"
    }), /*#__PURE__*/React.createElement("link", {
      rel: "apple-touch-icon",
      sizes: "180x180",
      href: "icons/apple-touch-icon.png"
    }), /*#__PURE__*/React.createElement("link", {
      rel: "icon",
      type: "image/svg+xml",
      href: "icons/favicon.svg"
    }), /*#__PURE__*/React.createElement("link", {
      rel: "alternate icon",
      type: "image/png",
      sizes: "32x32",
      href: "icons/favicon-32x32.png"
    }), /*#__PURE__*/React.createElement("link", {
      rel: "alternate icon",
      type: "image/png",
      sizes: "16x16",
      href: "icons/favicon-16x16.png"
    }), /*#__PURE__*/React.createElement("link", {
      rel: "alternate shortcut icon",
      href: "icons/favicon.ico"
    }), /*#__PURE__*/React.createElement("link", {
      rel: "manifest",
      href: "icons/site.webmanifest"
    })), /*#__PURE__*/React.createElement("div", {
      className: "app-root"
    }, /*#__PURE__*/React.createElement(GoogleAnalytics, {
      gaMeasurementId: Config.analyticsId,
      trackPageViews: {
        ignoreHashChange: true
      }
    }), /*#__PURE__*/React.createElement(QueryClientProvider, {
      client: client
    }, /*#__PURE__*/React.createElement(SearchContextProvider, null, /*#__PURE__*/React.createElement(NextThemesProvider, {
      attribute: "class"
    }, /*#__PURE__*/React.createElement(FlowbiteThemeProvider, {
      theme: FlowbiteTheme,
      applyTheme: FlowbiteThemeApply
    }, /*#__PURE__*/React.createElement(Component, pageProps)))))));
  }
}